"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "CommunityLogo___StyledSvg",
  componentId: "sc-1f22oil-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function CommunityLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M4.257 7.825a4.031 4.031 0 01-.075-.725c0-1.762 1.141-2.9 2.909-2.9.937 0 1.71.68 2.026 1.45h1.765c.316-.77 1.09-1.45 2.027-1.45 1.767 0 2.909 1.138 2.909 2.9 0 .473-.097.96-.255 1.45h1.5c.126-.484.21-.97.21-1.45 0-2.561-1.795-4.35-4.364-4.35-1.16 0-2.234.607-2.91 1.508-.675-.901-1.75-1.508-2.908-1.508-2.57 0-4.364 1.789-4.364 4.35 0 .24.028.483.06.725h1.47z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    d: "M15.598 10l-1.81 1.203-3-3.738-2.97 2.96L5.636 8.25 3.881 10H2v1.45h2.483l1.153-1.15 2.182 2.176 2.849-2.84 2.818 3.511 2.553-1.697H18V10h-2.402zM7.222 12.9a27.2 27.2 0 002.774 2.69 30.11 30.11 0 002.11-1.965h1.974a28.763 28.763 0 01-3.634 3.472.729.729 0 01-.893 0c-.159-.124-2.374-1.862-4.238-4.197h1.907z",
    fill: "currentColor"
  }));
}

var _default = CommunityLogo;
exports["default"] = _default;